import {Category} from './Category';
import {Labels} from './Labels';
import {UserData} from './UserData';

export class QuickConfigData {

  static readonly INCOMPATIBLE_PRODUCTLINE_OR_PRODUCT = 'incompatibleProductLineOrProduct';
  static readonly KB_RULE = 'kbRule';

  static create(quickConfigInit): QuickConfigData {
    return new QuickConfigData(
      quickConfigInit.categories,
      quickConfigInit.labels,
      quickConfigInit.userData,
      quickConfigInit.discounts,
      quickConfigInit.currentProduct,
      quickConfigInit.extendedSellPrice,
      quickConfigInit.leadTimeTotal,
      quickConfigInit.imageOptionUrl,
      quickConfigInit.imageTemplateUrl,
      quickConfigInit.hasKnowledgeBaseChanged,
      quickConfigInit.itemId,
      quickConfigInit.configStatus,
      quickConfigInit.incompatibleReason,
      quickConfigInit.incompatibleKind
    );
  }

  constructor(public categories: Category[],
              public labels: Labels,
              public userData: UserData,
              public discounts: any[],
              public product: any,
              public price = '',
              public leadTimeTotal = '',
              public imageOptionUrl = '',
              public imageTemplateUrl = '',
              public hasKnowledgeBaseChanged = false,
              public itemId = '',
              public configStatus = '',
              public incompatibleReason = '',
              public incompatibleKind = '') {
  }

  /**
   * FHS-4515: false when the IFE reports the product line / product as not configurable, i.e. the save
   * would be rejected. An IFE build that sends no configStatus is treated as configurable.
   */
  isProductConfigurable(): boolean {
    return this.configStatus !== QuickConfigData.INCOMPATIBLE_PRODUCTLINE_OR_PRODUCT;
  }

  /**
   * FHS-4515: true when the IFE classifies the refusal as a KB rule defect (a rule no selection can satisfy),
   * as opposed to one the user's selections could change. An absent kind counts as selections.
   */
  isProductDataIssue(): boolean {
    return !this.isProductConfigurable() && this.incompatibleKind === QuickConfigData.KB_RULE;
  }

  updateCategories(updatedCategories: Category[], extendedSellPrice: string) {
    this.categories = updatedCategories;
    this.price = extendedSellPrice;
  }
  updateProduct(product: any) {
    this.product = product;
  }

  updateDiscounts(discounts: any[]) {
    this.discounts = discounts;
  }

  findCategory(categoryId: string) {
    return this.categories.find(category => category.id === categoryId);
  }

  findParentSubcatInCategories(parentSubcatId: string) {
    return this.categories.map(category => category.parentSubcategories)
      .reduce((result, parentSubcat) => result.concat(parentSubcat), []) // flatten the parentSubcategories
      .find(parentSubcat => parentSubcat.id === parentSubcatId);
  }

  findFieldInCategories(fieldId: string) {
    return this.categories.map(category => category.parentSubcategories)
      .reduce((result, parentSubcat) => result.concat(parentSubcat), []) // flatten the parentSubcategories
      .map(parentSubcat => parentSubcat.fields)
      .reduce((result, field) => result.concat(field), []) // flatten the fields
      .find(field => field.id === fieldId);
  }

  allParentSubcatIds() {
    return this.categories.map(category => category.parentSubcategories.map(p => p.id))
      .reduce((ids, catIds) => ids.concat(catIds), []);
  }
}
